module.exports = __webpack_public_path__ + "img/dbapp_yhcx.a5153e3d.png";